<template>
    <v-container :id="cartWrapperId" class="">
        <v-row column justify-center align-center>
            <v-col cols="12 pa-0">
                <DynamicAlerts
                    :show="false"
                    msg="Example of an alert message"
                />
            </v-col>
            <v-col cols="12" md="12" class="py-0" v-show="webUser && !isCustomerConnected">
                <v-alert color="primary" elevation="2" type="warning" dense>
                    <div class="d-flex align-center">
                        <TranslatableStringComponent :tstring="{string: 'existingCustomer'}" />&nbsp;
                        <TranslatableStringComponent :tstring="{string: 'connectToYourCustomerAccount'}" />
                        <v-btn
                            color="white"
                            class="ml-2"
                            small
                            light
                            @click="showModal = true"
                            ><TranslatableStringComponent :tstring="{string: 'connect'}" /></v-btn
                        >
                    </div>
                </v-alert>
            </v-col>
            <v-col cols="12" :md="cartColsMd">
                <CartItems />
                <ShareablePanel v-if="!isCartEmpty" />
                <Coupon v-if="!isCartEmpty" />
            </v-col>
            <v-col v-if="!isCartEmpty" cols="12" md="4">
                <h2><TranslatableStringComponent :tstring="{string: 'cartTotals'}" /></h2>
                <CartTotals :is-cart="true" />
            </v-col>
        </v-row>
        <ConnectCustomerDialog
            :showModal="showModal"
            stepperValue="2"
            @handlePostCustomerConnect="handlePostCustomerConnect()"
            @handleDialog="showModal = false"
        />
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import CartItems from '~/components/CartItems.vue'
import CartTotals from '~/components/CartTotals.vue'
import Coupon from '~/components/Coupon.vue'
import DynamicAlerts from '~/components/DynamicAlerts.vue'
import ShareablePanel from '~/components/ShareablePanel.vue'
import ConnectCustomerDialog from '~/components/ConnectCustomerDialog.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
import handleSnackbar from '~/mixins/handleSnackbar'
export default {
    name: 'Cart',
    components: {
        CartItems,
        CartTotals,
        Coupon,
        DynamicAlerts,
        ShareablePanel,
        ConnectCustomerDialog,
        TranslatableStringComponent,
    },
    props: {
        filters: {
            type: Object,
            default: null,
        },
    },
    mixins: [handleSnackbar],
    data() {
        return {
            isEmailConfirmed: false,
            showModal: false,
        }
    },
    computed: {
        ...mapGetters({
            isCartEmpty: 'cart/isCartEmpty',
            isProduction: 'auth/isProduction',
            isCustomerConnected: 'auth/isCustomerConnected',
            webUser: 'auth/webUser'
        }),
        cartWrapperId() {
            return 'cart-wrapper'
        },
        showCheckoutButton() {
            return true
        },
        cartColsMd() {
            return this.isCartEmpty ? 12 : 8
        },
    },
    methods: {
        handlePostCustomerConnect() {
            this.showModal = false
            this.hitSnackbar(
                { string:'youAreNowConnectedToYourCustomerAccount'},
                null
            )
        },
    },
}
</script>
